module.exports = __webpack_public_path__ + "static/media/centerMatBlue10.2bdcd2fc.png";